import { useDraggable } from '@dnd-kit/core';

import type { PipelineCard as PipelineCardDto } from '@/pages/pipelines/common/types';

import { PipelineCard } from './card';
import { CardSlot } from './styled';

type Props = {
  card: PipelineCardDto;
  disabled: boolean;
  onSelect: (_cardId: string) => void;
};

export const PipelineDraggableCard = ({ card, disabled, onSelect }: Props) => {
  const { setNodeRef, attributes, listeners, isDragging } = useDraggable({
    id: card.id,
    disabled,
    data: { stage: card.stage },
  });

  return (
    <CardSlot
      ref={setNodeRef}
      data-testid="pipeline-card-slot"
      data-card-id={card.id}
      data-dragging-original={isDragging}
    >
      <PipelineCard
        card={card}
        dragHandleProps={{ ...attributes, ...listeners }}
        isDragging={isDragging}
        onSelect={onSelect}
      />
    </CardSlot>
  );
};
